import { Link } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../../../ricos-context/index.js";
import { getIsModalOpen, useModalState } from "./../../../../ricos-modals/modal-service-provider.js";
import { LINK_MODAL_ID } from "./../../../../_shared/link-modal/constants.js";
import { ToolbarButton } from "./../../../../_shared/toolbar-button/toolbar-button.js";
const LinkButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);
  const isModalOpen = useModalState(getIsModalOpen(LINK_MODAL_ID));
  const [referenceElement, setReferenceElement] = useState(null);
  const onClick = () => {
    toolbarItem.commands.click({ referenceElement, modalService });
  };
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      active: isModalOpen || toolbarItem.attributes.active,
      prefix: Link,
      tooltip: t(toolbarItem.presentation?.tooltip ?? "TextLinkButton_Tooltip"),
      onClick,
      ref: setReferenceElement,
      dataHook,
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
var LinkButton_default = LinkButton;
export {
  LinkButton_default as default
};
//# sourceMappingURL=LinkButton.js.map
